import { Box, Paper } from '@mui/material'
import { Routes, Route, Outlet } from 'react-router-dom'
import SettingsCalendar from './Calendar'
import AcademicYear from './AcademicYearProvider'
import SettingsSchoolAccess from './SchoolAccess'
import SettingsSchoolManagement from './SchoolManagement'
import PageHeader from 'components/AppBar/PageHeader'
import SettingsTabs, { tabConfig } from './Tabs'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import GradeSections from './GradeSections'
import Rooms from './Rooms'
import Periods from './Periods'
import Grading from './Grading'
import NoAccess from 'components/NoAccess'
import NotFound from 'components/NotFound'
import Protected from 'components/Protected'
import { useSession } from 'components/Providers'
import MarkingPeriods from './MarkingPeriods'

function Slot() {
  return (
    <Box maxWidth={'100%'}>
      <Outlet />
    </Box>
  )
}

export default function MainPage() {
  const basePath = '/settings'
  const { permissions, district } = useSession()


  return (
    <Box >
      <Box sx={{ mb: 2 }}>

        <PageHeader title={'Settings'} />
      </Box>
      <Paper elevation={0} sx={{ width: '100%', minHeight: '500px', p: 2, mb: 2 }}>
        {permissions['setting.setting'] ? (
          <>

            <SettingsTabs basePath={basePath} />
            <Routes>
              <Route path="/" element={<Slot />}>
                <Route index element={
                  <RedirectToFirstPermitted
                    basePath={basePath}
                    items={tabConfig.filter(tab => district?.isServiceProvider && tab.visibleAtProvider || !district?.isServiceProvider && tab.visibleAtCampus)}
                  />
                } />
                {district?.isServiceProvider && (
                  <>
                    <Route path="calendar/*" element={<Protected permission="setting.calendar"><SettingsCalendar /></Protected>} />
                    <Route path="academic-year/*" element={<Protected permission="setting.academic"><AcademicYear /></Protected>} />
                    <Route path="school-access/*" element={<Protected permission="setting.access"><SettingsSchoolAccess /></Protected>} />
                    <Route path="school-management/*" element={<Protected permission="setting.district"><SettingsSchoolManagement /></Protected>} />
                  </>
                )}
                <Route path="rooms/*" element={<Protected permission="setting.room"><Rooms /></Protected>} />
                {!district?.isServiceProvider && (
                  <>
                    <Route path="grade-sections/*" element={<Protected permission="setting.section"><GradeSections /></Protected>} />
                    <Route path="periods/*" element={<Protected permission="setting.period"><Periods /></Protected>} />
                    <Route path="grading/*" element={<Protected permission="setting.grading"><Grading /></Protected>} />
                    <Route path="marking-periods/*" element={<Protected permission="setting.setting"><MarkingPeriods /></Protected>} />
                  </>
                )}
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </>
        ) : (
          <NoAccess />
        )}
      </Paper>
    </Box>
  )
}
